var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsset3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 184.95 184.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        stroke: #c9c9c9;\n        stroke-miterlimit: 10;\n        stroke-width: .17px;\n      }\n\n      .cls-2 {\n        fill: #cc0202;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 147.91,
    y: 110.95,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 147.91,
    y: 123.27,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 160.23,
    y: 123.27,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 135.59,
    y: 123.27,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 135.59,
    y: 110.95,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 123.27,
    y: 110.95,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 135.59,
    y: 98.64,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 98.64,
    y: 86.32,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 86.32,
    y: 98.64,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 86.32,
    y: 86.32,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74,
    y: 86.32,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 86.32,
    y: 74,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 123.27,
    y: 98.64,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 172.55,
    y: 172.55,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 147.91,
    y: 160.23,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 160.23,
    y: 147.91,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 147.91,
    y: 147.91,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 110.95,
    y: 98.64,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 110.95,
    y: 147.91,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 123.27,
    y: 147.91,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 123.27,
    y: 160.23,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 123.27,
    y: 135.59,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 110.95,
    y: 135.59,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 110.95,
    y: 123.27,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 98.64,
    y: 135.59,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 98.64,
    y: 123.27,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 98.64,
    y: 110.95,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 147.91,
    y: 61.68,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 147.91,
    y: 49.36,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 160.23,
    y: 49.36,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 135.59,
    y: 49.36,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 135.59,
    y: 61.68,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 123.27,
    y: 61.68,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 135.59,
    y: 74,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 123.27,
    y: 74,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 172.55,
    y: 0.09,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 147.91,
    y: 12.4,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 160.23,
    y: 24.72,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 147.91,
    y: 24.72,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 110.95,
    y: 74,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 110.95,
    y: 24.72,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 123.27,
    y: 24.72,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 123.27,
    y: 12.4,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 123.27,
    y: 37.04,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 110.95,
    y: 37.04,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 110.95,
    y: 49.36,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 98.64,
    y: 37.04,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 98.64,
    y: 49.36,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 98.64,
    y: 61.68,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.72,
    y: 61.68,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.72,
    y: 49.36,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.4,
    y: 49.36,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 37.04,
    y: 49.36,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 37.04,
    y: 61.68,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 49.36,
    y: 61.68,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 37.04,
    y: 74,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 49.36,
    y: 74,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.09,
    y: 0.09,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.72,
    y: 12.4,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.4,
    y: 24.72,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.72,
    y: 24.72,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 61.68,
    y: 74,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 61.68,
    y: 24.72,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 49.36,
    y: 24.72,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 49.36,
    y: 12.4,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 49.36,
    y: 37.04,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 61.68,
    y: 37.04,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 61.68,
    y: 49.36,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 74,
    y: 37.04,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 74,
    y: 49.36,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 74,
    y: 61.68,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.72,
    y: 110.95,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.72,
    y: 123.27,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.4,
    y: 123.27,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 37.04,
    y: 123.27,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 37.04,
    y: 110.95,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 49.36,
    y: 110.95,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 37.04,
    y: 98.64,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 49.36,
    y: 98.64,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.09,
    y: 172.55,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.72,
    y: 160.23,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.4,
    y: 147.91,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.72,
    y: 147.91,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 61.68,
    y: 98.64,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 61.68,
    y: 147.91,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 49.36,
    y: 147.91,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 49.36,
    y: 160.23,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 49.36,
    y: 135.59,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 61.68,
    y: 135.59,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 61.68,
    y: 123.27,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 74,
    y: 135.59,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 74,
    y: 123.27,
    width: 12.32,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 74,
    y: 110.95,
    width: 12.32,
    height: 12.32
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset3);
export default __webpack_public_path__ + "static/media/Asset3.864394d3267c444a7d2859cd4b340487.svg";
export { ForwardRef as ReactComponent };